// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/.pnpm/css-loader@3.6.0_webpack@4.47.0/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n#sale-echart[data-v-236e4aa0]{\n  height:420px;\n  overflow: hidden;\n  margin: 0 auto;\n}\n.wuzq-content[data-v-236e4aa0] {\n  padding: 0;\n}\n\n", ""]);
// Exports
module.exports = exports;
